import { ColorConf } from "@/config/color";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BackgroundContainer = styled(Box)({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 32,
  padding: "0 24px",
  backgroundImage: `url(${"/images/hero-bg1.png"})`,
  backgroundSize: "100% 100%",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  width: "100%",
  "@media (min-width: 600px)": {
    padding: "0 32px",
  }
});

export const _ContentTitleWithMarginTop = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: "23px",
  lineHeight: "28px",
  fontWeight: 700,
  marginBottom: 40,
  marginTop: 80,
  textAlign: "center",
  letterSpacing: "0.1em",
  color: ColorConf.HeroPrimaryColor
});

export const H2 = styled(Typography)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 23,
  lineHeight: "28px",
  fontWeight: 700,
});

export const H4 = styled(Typography)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 19,
  lineHeight: "24px",
  fontWeight: 700,
});

export const H5 = styled(Typography)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 17,
  lineHeight: "22px",
  fontWeight: 700,
  color: ColorConf.HeroPrimaryText
});

export const H6 = styled(Typography)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 15,
  lineHeight: "20px",
  fontWeight: 700,
});

export const Title = styled(Typography)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 17,
  lineHeight: "24px",
  fontWeight: 500,
  color: ColorConf.HeroPrimaryText,
});

export const Subtitle = styled(Typography)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 15,
  lineHeight: "20px",
  fontWeight: 500,
})

export const Body1 = styled(Typography)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 15,
  lineHeight: "20px",
  fontWeight: 400,
  color: ColorConf.HeroSecondaryText,
  letterSpacing: "0.1em",
})

export const Body2 = styled(Typography)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 13,
  lineHeight: "16px",
  fontWeight: 400,
  color: ColorConf.HeroSecondaryText
})
